import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExamService } from 'src/app/core/exam.service';
import { Course } from 'src/app/models/course.model';
import { ExamLearnset } from 'src/app/models/exam-learnset.model';

@Component({
  selector: 'app-create-exam',
  templateUrl: './create-exam.component.html',
  styleUrls: ['./create-exam.component.scss'],
  standalone: false
})
export class CreateExamComponent {

  @Input() course?: Course;
  
  examId?: number;
  isLoading: boolean = false;

  totalCount: number = 0;

  errorVisible: boolean = false;
  errorText: string = '';

  examLearnsets?: ExamLearnset[];

  constructor(
    private route: ActivatedRoute,
    private examService: ExamService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(paramMap => {
      this.examId = Number(paramMap.get('examId'));
    });
  }

  createExam() {
    this.isLoading = true;
    if (this.totalCount > 0) {
      this.examService.createExam(this.course!.id!, this.examLearnsets!.filter((examLearnset) => examLearnset.isSelected)).subscribe((result) => {
        const examId = result.id;
        this.isLoading = false;
        this.router.navigate([`courses/${this.course!.id!}/exam/${examId}`]);
      });
    } else {
      this.isLoading = false;
      this.showError('Bitte wähle mindestens ein Lernset aus.');
    }
  }

  showError(errorText: string) {
    this.errorText = errorText;
    this.errorVisible = true;
  }

  handleExamLearnsetsChange(examLearnsets: ExamLearnset[]) {
    this.examLearnsets = examLearnsets;
  }
}
